<template>
    <modal
        v-if="showModal"
        @close="showModal = false">
        <template #header>
            <i class="fa fa-check"></i>
            {{ __('Toegevoegd aan je winkelwagen') }}
        </template>
        <template #default>
            <div class="mao-attToCartItem">
                <div
                    class="mao-thumbImage mao-thumbImage--60x60 mao-thumbImage--bgWhite"
                    id="cart-add-image">
                    <img
                        :src="product.shoppingImage"
                        :alt="product.title"
                        class="list-image-shopping"
                        style="margin-top: -10px" />
                </div>

                <div
                    class="mao-productItemTitle mao-font600"
                    id="cart-add-title">
                    {{ product.title }}
                </div>

                <div class="mao-price-component mao-price-component--18px">
                    <span class="mao-price-component__main">
                        <span id="cart-add-price-new">{{ toFixedLocal(currentPrice) }}&nbsp;</span>
                    </span>
                    <span
                        v-if="oldPrice > currentPrice"
                        class="mao-price-component__secondary"
                        id="cart-add-price-old">
                        {{ toFixedLocal(oldPrice) }}
                    </span>
                </div>
            </div>

            <div class="row mao-continueOrProceed">
                <div class="col-sm-6 col-sm-push-6 mao-continueOrProceed__proceed">
                    <a :href="nextAction">
                        <button class="mao-button black buttonMobile">
                            {{ __('Bekijk je winkelwagen') }}
                            <i class="fa fa-angle-right"></i>
                        </button>
                    </a>
                </div>

                <div class="col-sm-6 col-sm-pull-6">
                    <span
                        @click="showModal = false"
                        href="#"
                        class="mao-blueLink"
                        data-dismiss="modal">
                        <i class="fa fa-angle-left"></i>
                        {{ __('Verder winkelen') }}
                    </span>
                </div>
            </div>

            <hr class="mao-hr" />

            <template v-if="product?.alternativeData?.product !== undefined">
                <h2 class="modal-title">
                    Bespaar ruim {{ Math.abs(Math.round(product.alternativeData.difference)) }}% met ons alternatief!
                </h2>
                <p>Waarom teveel betalen als het goedkoper kan.</p>
                <div class="row">
                    <div class="col-sm-12">
                        <div
                            class="box"
                            style="background-color: #edf8e9">
                            <div class="row">
                                <div class="col-sm-2">
                                    <div
                                        class="mao-thumbImage mao-thumbImage--60x60 mao-thumbImage--bgWhite"
                                        id="cart-add-image">
                                        <img
                                            :src="product.alternativeData.product.shoppingImage"
                                            :alt="product.alternativeData.product.title"
                                            class="list-image-shopping"
                                            style="max-width: 60px" />
                                    </div>
                                </div>
                                <div class="col-sm-10 mao-price-component mao-price-component--18px">
                                    <p>
                                        <strong>{{ product.alternativeData.product.title }}</strong>
                                    </p>
                                    <span class="mao-price-component__main">
                                        <span>{{ toFixedLocal(alternativePrice) }}&nbsp;</span>
                                    </span>
                                    <span
                                        v-if="oldAlternativePrice > alternativePrice"
                                        class="mao-price-component__secondary"
                                        id="cart-add-price-old">
                                        {{ toFixedLocal(oldAlternativePrice) }}
                                    </span>

                                    <p style="margin-top: 10px">
                                        <span
                                            style="font-size: 10pt"
                                            class="ticked">
                                            <strong>
                                                {{
                                                    product.alternativeData.product.fastDeliveryPrices[0].supplierDeliveryText.orderMoment
                                                }},
                                            </strong>
                                            {{ product.alternativeData.product.fastDeliveryPrices[0].supplierDeliveryText.deliveryMoment }}
                                        </span>
                                    </p>

                                    <button
                                        class="mao-button yellow"
                                        style="width: auto"
                                        @click="changeProduct">
                                        <i class="fa fa-refresh"></i>
                                        {{ __('Vervangen') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </modal>
</template>

<script setup lang="ts">
    import Modal from './Modal.vue';
    import {computed, ref} from 'vue';
    import {siteSettings as siteSettingsStore, shoppingCartStore} from './Store.ts';

    let showModal = ref(false);
    let product = ref({});
    const nextAction = window.route.shoppingcart.cart;
    const siteSettings = siteSettingsStore();
    const cart = shoppingCartStore();

    defineExpose({
        showModal,
        product,
    });

    const currentPrice = computed(() => product.value.netPrice * siteSettings.btw);
    const alternativePrice = computed(() => product.value.alternativeData.netPrice * siteSettings.btw);
    const oldPrice = computed(() => product.value.grossPrice * siteSettings.btw);
    const oldAlternativePrice = computed(() => product.value.alternativeData.product.fastDeliveryPrices[0].grossPrice * siteSettings.btw);

    const changeProduct = () => {
        cart.removeItem(product.value);
        cart.addItem(cart.filterProductFields(product.value.alternativeData.product), product.value.orderQuantity);
        showModal.value = false;
    };
</script>

<style scoped>
    .box {
        border: 1px solid #319800;
        border-radius: 2px;
        padding: 25px;
        width: 100%;
    }

    .modal-title {
        color: #e33b29;
        font-size: 16pt !important;
        font-weight: 600 !important;
    }
</style>
